//
//
//
//

export default {
  name: 'ViewedAnalytics',
  props: {
    event: {
      type: String,
      default: '',
    },
  },
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        console.log(`Viewed ${this.event}`);
      }
    },
  },
};
